import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid, IonImg, IonIcon, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonButton, IonAlert, useIonViewDidEnter } from '@ionic/react';
import React, { useContext, useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BiblePlanManagerPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { useDispatch, useSelector } from 'react-redux';
import { SelectReadingPlans, UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';
import ReadingPlans, { ReadingPlanCodes, ReadingPlanCodeValues } from '../../data/ReadingPlans';
import { pencil, people, person, trashBin } from 'ionicons/icons';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { useHistory } from 'react-router';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import { SelectActiveGroupId, SelectGroupIds, SelectGroups, UpdateActiveGroupId, UpdateGroup } from '../../store/FellowshipSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import IFellowshipGroup from '../../interfaces/IFellowshipGroup';
import { SelectCurrentUser, SelectLoginStatus } from '../../store/UserSlice';
import FellowshipSettingsService from '../../services/FellowshipSettingsService';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';

const BiblePlanManagerPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const readingPlans = useSelector(SelectReadingPlans);
  const userGroupIds = useSelector(SelectGroupIds);
  const dbService = useContext(ServerDBContext);
  const userGroups = useSelector(SelectGroups);
  const currentUser = useSelector(SelectCurrentUser);
  const [planIdToDelete, setPlanIdToDelete] = useState(0);
  const [groupIdPlanToDelete, setGroupIdPlanToDelete] = useState<string | undefined>('');
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [ReadingPlanRecords, setReadingPlanRecords] = useState<IReadingPlanRecord[]>([])

  useEffect(() => {
    ReadingPlanRecordService.getReadingPlanRecords().then(planRecordsResponse => {
      if(planRecordsResponse.Success) {
        const fullRecords = readingPlans.map(plan => planRecordsResponse.Data?.find(readingPlan => readingPlan.id === plan.id))
                              .filter(result => result !== undefined && result.readingPlanCode !== ReadingPlanCodes.bible) as IReadingPlanRecord[];
        setReadingPlanRecords(fullRecords)
      }
    });
    
  },[readingPlans]);
  

  const adminGroupPlan = (currentUserId?: string, groupId?: string) => {
    const groupInfo = groupId && userGroups?.hasOwnProperty(groupId) ? userGroups[groupId] : undefined;
    return currentUserId && currentUserId === groupInfo?.group.creatorId ? groupInfo.group : undefined;
  }

  const deleteReadingPlan = (id: number, group?: IFellowshipGroup) => {
    ReadingPlanRecordService.deleteReadingPlanRecord(id).then(result => {
      if(result.Success){
        UpdateActivePlanByIdAsync(dispatch, userGroupIds);
         if(group) {
          dbService?.updateGroup({...group, syncCode: ''}, true).then(result => {
            if(result?.Success) {
              dispatch(UpdateGroup({...result.Data}));
            }
          });
        }
      }
    })
  }

  return (
    <IonPage className="bible-plan-manager-page">
      <PageHeader {...props} showBackButton={true}></PageHeader>
      <IonContent color="light">
        <IonGrid fixed={true}>
          <IonRow >
          {ReadingPlanRecords.length ? ReadingPlanRecords?.map((plan, index) => (
              <IonCol sizeMd="6" sizeLg='4' sizeXs='12' key={`reading-plan-schedule-${index}`}>
                <IonCard mode='ios'>
                  <img alt={`.${ReadingPlans[plan.readingPlanCode as ReadingPlanCodeValues].sessionsURL}plan-banner.jpg`} src={`.${ReadingPlans[plan.readingPlanCode as ReadingPlanCodeValues].sessionsURL}plan-banner.jpg`} />
                  <IonCardHeader>
                    <IonCardTitle className="plan-name">
                      <IonIcon className="plan-name-icon" icon={plan.groupId ? people : person} /> {plan.name}
                    </IonCardTitle>
                    <IonCardSubtitle>{plan.readingPlan}</IonCardSubtitle>
                  </IonCardHeader>
                  <IonCardContent className="plan-card-content">
                    <b>Plan Type:</b> {plan.groupId ? 'Group' : 'Personal'}<br />
                    <b>Start Date:</b> {plan.startDate.toLocaleDateString()}<br />
                    <b>Readings Per Day:</b> {plan.sessionsPerDay}<br />
                    <i><b>Last Updated:</b> {new Date(plan.modifiedDate!).toLocaleDateString()}</i><br />
                  </IonCardContent>
                  <IonButton fill="clear" color={'primary'} onClick={()=>
                    history.push(`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${plan?.readingPlanCode}/${plan?.id}/${plan.groupId}`, {direction: 'forward'})}>Update</IonButton>
                  { (plan.groupId === '' || adminGroupPlan(currentUser?.id, plan.groupId)) &&
                  <IonButton fill="clear" color={'primary'} onClick={() => {
                    setPlanIdToDelete(plan.id);
                    setGroupIdPlanToDelete(plan.groupId);
                    setShowDeleteConfirmation(true);
                  }}>Delete</IonButton> }
                </IonCard>
              </IonCol>
          )) : <IonCol className='bible-plan-manager-none'>NO READING PLANS SET UP</IonCol>}
          </IonRow>
        </IonGrid>
        <IonAlert
          isOpen={showDeleteConfirmation}
          onDidDismiss={() => setShowDeleteConfirmation(false)}
          cssClass='my-custom-class'
          header={'WARNING: CONFIRM'}
          subHeader={'Are you sure you want to delete this plan?'}
          message={groupIdPlanToDelete ? `This action cannot be undone. If this is a group plan, deleting the plan will result in deleting the plan for every group member. Please make sure they are not using this plan before deleting it.` : 
            `This action cannot be undone. All your recorded check days read will be deleted and can't be recovered once deleted. Are you should you want to delete this plan?`}
          buttons={[
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel: DELETE PLAN');
              }
            },
            {
              text: 'YES',
              handler: () => {
                deleteReadingPlan(planIdToDelete, adminGroupPlan(currentUser?.id, groupIdPlanToDelete));
              }
            }
          ]}
        />
      </IonContent>
    </IonPage>
  );
};

export default BiblePlanManagerPage;